import React, { useEffect, useState } from 'react';

import AllInfoBotContainer from '../AllInfoBotContainer/AllInfoBotContainer';
import UsersList from '../UsersList/UsersList';
import UsersMessageContainer from '../UsersMessageContainer/UsersMessageContainer';
import styles from './ActiveBotContainer.module.scss';
import ScreenHeader from '../ScreenHeader/ScreenHeader';
import { PenIcon } from '../../assets/icons/PenIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUpdateBot } from '../../store/slices/integrationSlice';
import { TrashIcon } from '../../assets/icons/TrashIcon';
import {
    deleteBot,
    getTelegramBotUsersList,
} from '../../utils/api/actions/integrations/tgBot';

export default function ActiveBotContainer({ data }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const botId = location.pathname.split('/').pop();
    const id =
        useSelector((state) => state.user?.data?.id) ||
        localStorage.getItem('@storage_User_Id');

    const [activeNav, setActiveNav] = useState('all info');

    useEffect(() => {
        dispatch(getTelegramBotUsersList(botId));
        return;
    }, [botId, dispatch]);

    const navItems = [
        {
            name: 'Общая информация',
            value: 'all info',
            component: <AllInfoBotContainer botId={botId} />,
        },
        {
            name: 'Пользователи',
            value: 'users',
            component: <UsersList />,
        },
        {
            name: 'Отправить сообщение',
            value: 'send message',
            component: <UsersMessageContainer />,
        },
    ];

    const valueObserver = (e) => setActiveNav(e.target.id);

    const renderNavItems = (arr) => {
        return arr.map((el, index) => {
            return (
                <p
                    key={el.value}
                    className={
                        el.value === activeNav
                            ? styles.activeNavItem
                            : styles.navItem
                    }
                    id={el.value}
                    onClick={valueObserver}
                >
                    {el.name}
                </p>
            );
        });
    };

    const renderBodyItems = (arr) => {
        return arr
            .map((item, index) => {
                if (item.value === activeNav) {
                    return <div key={item.value}>{item.component}</div>;
                }
                return null;
            })
            .filter(Boolean);
    };

    const handleSetEditMode = () => {
        dispatch(setUpdateBot(true));
        navigate(`/integration/telegram-bot/new?id=${botId}`);
    };

    const handleDeleteBot = () => {
        dispatch(deleteBot(botId, id));
        navigate(`/integration`);
    };

    const actionButtons = [
        {
            title: 'Изменить',
            icon: <PenIcon size={16} fill={'#3e8fcb'} />,
            className: styles.editButton,
            titleClassName: styles.titleEditButton,
            onClick: handleSetEditMode,
        },
        {
            title: 'Удалить',
            icon: <TrashIcon size={16} fill={'#cb3e3e'} />,
            className: styles.deleteButton, // rgba(203, 62, 62, 0.15)
            titleClassName: styles.titleDeleteButton,
            onClick: handleDeleteBot,
        },
    ];

    return (
        <div className={styles.container}>
            <ScreenHeader
                actions={actionButtons}
                title={'Интеграции'}
                path={'/integration'}
            />
            <div className={styles.navContainer}>
                {renderNavItems(navItems)}
            </div>
            <div className={styles.body}>{renderBodyItems(navItems)}</div>
        </div>
    );
}
